export default __webpack_public_path__ + "static/media/image11.cf5935d4.jpeg";